import { render, staticRenderFns } from "./professional-info.vue?vue&type=template&id=719ed489&scoped=true&"
import script from "./professional-info.vue?vue&type=script&lang=js&"
export * from "./professional-info.vue?vue&type=script&lang=js&"
import style0 from "./professional-info.vue?vue&type=style&index=0&id=719ed489&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719ed489",
  null
  
)

export default component.exports